import Data from "../types/Data";

export default function receiptHasNoItems(data: Data, receiptId: number) {
  let receipt = data.Receipt[receiptId];
  return receipt.itemIds.length === 0;
}
